<template>
  <BaseModal
    :name="name"
    :visible="props.visible"
    :closeButton="closeButton"
    :closeOutside="true"
    :classes="classes"
    :before-open="onBeforeOpen"
    :before-close="onBeforeClose"
    :style="{ maxWidth: maxWidthModal }"
    @close="emit('close')"
    class="dialog">
    <div class="modal">
      <template v-if="hasSlot('custom')">
        <slot name="custom"></slot>
      </template>
      <template v-else>
        <div class="modal__header" v-if="hasSlot('header')">
          <slot name="header"></slot>
        </div>
        <div class="modal__body" v-if="hasSlot('body')">
          <slot name="body"></slot>
        </div>
        <div class="modal__footer" v-if="hasSlot('footer')">
          <slot name="footer" :onCancel="onClose"></slot>
        </div>
      </template>
    </div>
  </BaseModal>
</template>

<script setup>
import { useSlots } from "vue";
import BaseModal from "@/components/ui/modal/baseModal.vue";

const props = defineProps({
  name: {},
  visible: {},
  classes: {},
  beforeOpen: {},
  beforeClose: {},
  opened: {},
  closed: {},
  maxWidthModal: {},
  closeButton: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["close"]);
const slots = useSlots();
const hasSlot = (name) => !!slots[name];

const onBeforeOpen = (params) => {
  if (props.beforeOpen) {
    props.beforeOpen(params);
  }
};

const onBeforeClose = () => {
  if (props.beforeClose) {
    props.beforeClose();
  }
};

const onClose = () => {
  emit("close");
};
</script>

<style scoped>
/* to prevent the default browser styling for the dialog element */
.dialog {
  color: unset;
  max-width: unset;

  @media (max-width: 575px) {
    padding: 30px 20px;
  }
}
</style>
